import React from 'react';
import classnames from 'classnames';
import { Row } from 'antd';
import styles from './LayoutCardList.module.scss';
import { ColProps } from 'antd/lib/col';
import LayoutCard, { LayoutCardData, LayoutCardSize, LayoutCardType } from '../LayoutCard';
import { defaultHorizontalGutter } from 'src/utils/grid';

interface LayoutCardListProps {
  type?: LayoutCardType;
  size?: LayoutCardSize;
  bordered?: boolean;
  objectFit?: 'cover' | 'contain';
  items: LayoutCardData[];
  colProps?: ColProps;
  className?: string;
  wrap?: boolean;
  children?: React.ReactNode;
  truncateTitle?: boolean;
  dynamicRoute?: boolean;
}

const LayoutCardList: React.FunctionComponent<LayoutCardListProps> = (
  props: LayoutCardListProps
) => {
  const {
    items,
    colProps,
    className,
    wrap = true,
    children,
    truncateTitle = false,
    objectFit = 'cover',
    ...restProps
  } = props;
  return (
    <section className={classnames(styles.container, className)}>
      <Row gutter={[defaultHorizontalGutter, 40]} wrap={wrap}>
        {items.map((item, idx) => (
          <LayoutCard
            objectFit={objectFit}
            truncateTitle={truncateTitle}
            key={idx}
            data={item}
            colProps={colProps || item.colProps}
            {...restProps}
          />
        ))}
        {children}
      </Row>
    </section>
  );
};

export default LayoutCardList;
